import { useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { SwitchInput } from '@calendly/ui/components/switch-input';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
const statusToggleCss = "s1i89zbz";
const StatusToggle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(statusToggleCss, props.className)} />;
});
export const StatusField = ({
  name
}) => {
  const [{
    value: enabled
  }, _, {
    setValue
  }] = useFormField({
    name
  });
  return <div id={name}>
      <BodyText size="medium">{I18n.t('publisher.organization.headers.status')}</BodyText>
      <StatusToggle>
        <div>
          {enabled ? I18n.t('publisher.action.on') : I18n.t('publisher.action.off')}
        </div>
        <SwitchInput checked={enabled} onChange={() => setValue(!enabled)} name={name} />
      </StatusToggle>
    </div>;
};

require("./status_field.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./status_field.js");